import { connect } from 'react-redux'
import AttachmentsPanel from './AttachmentsPanel'
import { State } from '../../dataStore/reducers/reducerType'

const mapStateToProps = (state: State) => ({
  channelId: String(state.config.channelId),
  webcastId: String(state.config.webcastId),
  userTimezone: state?.user?.data?.timeZone
})

export default connect(mapStateToProps, null)(AttachmentsPanel)
